import {
  CalendarOutlined,
  PlusOutlined,
  DownloadOutlined,
  CloseOutlined,
  ExclamationCircleTwoTone,
  FileTextOutlined,
  ExclamationCircleFilled,
  EditOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';

import React, { useCallback, useEffect, useState } from 'react';

import {
  Space,
  message,
  Typography,
  Card,
  Divider,
  Dropdown,
  Row,
  Col,
  Table,
  Collapse,
  Select,
  Input,
  Button,
  Form,
  Alert,
  Tag,
  DatePicker,
  InputNumber,
  Modal,
  Radio
} from 'antd';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';

import ReturnDetails from './return-details';
import getResponse from '../../../API_Utils/APIUtil/ApiClient';
import apiConfig from '../../../API_Utils/APIUtil/ApiConfig';
import CallApi from '../../../API_Utils/APIUtil/CallApi';
import { PATH } from '../../../API_Utils/constants';
import {
  getError,
  getFormattedAmount,
  getDateFromISO,
  getFormattedNumber,
  getHistoryClient,
  downloadfileFromString,
  showErrorMessage,
  getSalesOrderClient
} from '../../../clientUtils';
import { CommonModalFooter, ModalWrapper } from '../../../Components/Common';
import Address from '../../../Components/Common/Address';
import CustomHeader from '../../../Components/Common/CustomHeader';
import DocumentCard from '../../../Components/Common/DocumentCard';
import AppLayout from '../../../Components/Common/Layout';
import Overview from '../../../Components/Common/Overview';
import UpdateLrModal from '../../../Components/Common/UpdateLrModal';
import LmDateModal from '../../../Components/Sales/DomesticSalesOrder/LmDateModal';
import * as Constants from '../../../constants';
import { GetColumns } from '../../purchase-request/columns';

const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;
const buttonStyle = { background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit' };

const STN_ACTION_TYPES = {
  REVERSE_STN: 'REVERSE_STN',
  STN_INVOICE: 'STN_INVOICE',
  STN_DC: 'STN_DC'
};

const STN_ACTIONS_CONFIG = {
  [STN_ACTION_TYPES.REVERSE_STN]: {
    title: 'Generate Reverse STN',
    confirmMessage: 'Are you sure you want to generate Reverse STN for this Return Order?',
    successMessage: 'Reverse STN generated successfully',
    apiConfig: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/generate-stn-cn`,
      method: 'POST'
    }
  },
  [STN_ACTION_TYPES.STN_INVOICE]: {
    title: 'Generate STN Document',
    confirmMessage: 'Are you sure you want to generate STN Invoice for this Return Order?',
    successMessage: 'STN Invoice generated successfully',
    apiConfig: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/generate-stn-invoice`,
      method: 'POST'
    }
  },
  [STN_ACTION_TYPES.STN_DC]: {
    title: 'Generate STN Document',
    confirmMessage: 'Are you sure you want to generate STN DC for this Return Order?',
    successMessage: 'STN DC generated successfully',
    apiConfig: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/generate-stn-dc`,
      method: 'POST'
    }
  }
};

const LABEL_STYLE = {
  width: 150,
  color: '#454C53'
};

const CONTENT_STYLE = {
  maxWidth: 260,
  color: '#1A1D21'
};
// const buttonStyle = { background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit' };

const ReturnDetailsDelivered = ({ ifVendor }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState({
    generateCreditNote: false
  });
  const { return_order, grn_list, actions, transitions } = details || {};
  const {
    status,
    updated_by,
    updated_on,
    type,
    ro_number,
    lr_number,
    dispatched_date,
    delivered_date,
    active_ewaybill
  } = return_order || {};
  const [documentCancelRemark, setDocumentCancelRemark] = useState('');
  const [documentCancelReason, setDocumentCancelReason] = useState('');
  const [cancelDocumentType, setCancelDocumentType] = useState('');
  const [cancelOptions, setCancelOptions] = useState({});
  const [openModal, setOpenModal] = useState('');
  const [creditNoteParams, setCreditNoteParams] = useState({ salesModel: null });
  const [stnActionType, setStnActionType] = useState(null);
  const [stnCancelOption, setStnCancelOption] = useState(null);

  const SOType = Constants.INTERNATIONAL_SO_TYPES.find((ty) => ty.value === type);

  useEffect(() => {
    const getDetails = () => {
      const path = {
        ...apiConfig.return.detail,
        path: apiConfig.return.detail.path(id)
      };

      CallApi(
        path,
        undefined,
        undefined,
        undefined,
        (response) => setDetails(response),
        (error) => message.error(getError(error))
      );
    };

    getDetails();
  }, []);

  useEffect(() => {
    if (cancelDocumentType) {
      const path = {
        ...apiConfig.return.cancellationOptions,
        path: apiConfig.return.cancellationOptions.path(id)
      };
      const params = { document_type: cancelDocumentType };

      CallApi(
        path,
        params,
        undefined,
        { start: () => setLoading('CANCEL_OPTIONS'), stop: () => setLoading('') },
        (response) => setCancelOptions(response),
        (error) => {
          showErrorMessage(error);
          setOpenModal('');
          setCancelDocumentType('');
        }
      );
    }
  }, [cancelDocumentType]);

  // const handleGenerateCreditNote = () => {
  //   setLoading({ ...loading, generateCreditNote: true });
  //   const path = {
  //     ...apiConfig.return.generateCreditNote,
  //     path: apiConfig.return.generateCreditNote.path(id)
  //   };

  //   CallApi(
  //     path,
  //     undefined,
  //     undefined,
  //     undefined,
  //     () => navigate(0),
  //     (error) => {
  //       message.error(getError(error));
  //       setLoading({ ...loading, generateCreditNote: false });
  //     }
  //   );
  // };

  const { return_type, sales_model } = details?.return_order || {};
  const typeOptionMap = {
    PLATFORM_REJECTION: ['OR', 'SOR'],
    STOCK_CORRECTION: ['OR', 'SOR'],
    QC_PLATFORM_REJECTION: ['OR', 'SOR'],
    QC_STOCK_CORRECTION: ['OR', 'SOR'],
    QC_EXCESS: null,
    EXCESS: null,
    OTHER: ['OR', 'SOR'],
    B2C_RETURN: null,
    REFURBISH_INTERNAL: null,
    REFURBISH_EXTERNAL: null,
    BUYER_STOCK_TRANSFER: null,
    DF: ['DF']
  };
  const getCreditNoteContent = (type, salesModel) => {
    if (salesModel) {
      return (
        <div>
          <ExclamationCircleTwoTone twoToneColor="#faad14" />
          <Text style={{ marginLeft: 10 }}>Are you sure you want to Generate a Credit Note?</Text>
        </div>
      );
    }
    const options = typeOptionMap[type];
    if (!options) {
      return (
        <div>
          <ExclamationCircleTwoTone twoToneColor="#faad14" />
          <Text style={{ marginLeft: 10 }}>Are you sure you want to Generate a Credit Note?</Text>
        </div>
      );
    }
    return (
      <Space className="w-100" direction="vertical">
        <Text className="fw-500 required-after">Please select Sales Model</Text>
        <Select
          className="w-100"
          onChange={(value) => setCreditNoteParams((prev) => ({ ...prev, salesModel: value }))}
          options={options?.map((option) => ({
            label: option,
            value: option
          }))}
        />
      </Space>
    );
  };
  const validateCreditNoteParams = (type, salesModel) => {
    if (salesModel) return true;
    const options = typeOptionMap[type] || [];
    const isSalesModelRequired = options.length > 0;
    const isSalesModelSelected = creditNoteParams?.salesModel && options.includes(creditNoteParams?.salesModel);
    if (isSalesModelRequired && !isSalesModelSelected) {
      return false;
    }
    return true;
  };
  const handleGenerateCreditNote = () => {
    // setLoading({ ...loading, generateCreditNote: true });
    const path = {
      ...apiConfig.return.generateCreditNote,
      path: apiConfig.return.generateCreditNote.path(id)
    };

    CallApi(
      path,
      creditNoteParams.salesModel ? { salesModel: creditNoteParams.salesModel } : undefined,
      undefined,
      {
        start: () => setLoading({ ...loading, generateCreditNote: true }),
        stop: () => setLoading({ ...loading, generateCreditNote: false })
      },
      () => navigate(0),
      (error) => {
        message.error(getError(error));
        // setLoading({ ...loading, generateCreditNote: false });
      }
    );
  };
  const generateCreditNoteModal = (
    <ModalWrapper
      content={getCreditNoteContent(return_type, sales_model)}
      footer={
        <CommonModalFooter
          // dangerSubmitButton
          ifSubmitDisabled={loading.generateCreditNote || !validateCreditNoteParams(return_type, sales_model)}
          isCancelDisabled={loading.generateCreditNote}
          loading={loading.generateCreditNote}
          onCancel={() => {
            if (!loading.generateCreditNote) setOpenModal('');
          }}
          onSubmit={handleGenerateCreditNote}
          submitButtonLabel="Generate Credit Note"
        />
      }
      onCancel={() => {
        setOpenModal('');
      }}
      open={openModal === 'GENERATE_CREDIT_NOTE'}
      title="Generate Credit Note"
      // loading={loading === 'CANCEL_OPTIONS'}
    />
  );

  // const generateCreditNote = () => {
  //   confirm({
  //     title: 'Generate Credit Note?',
  //     icon: <ExclamationCircleFilled />,
  //     content: 'Are you sure you want to Generate a Credit Note?',
  //     okType: 'primary',
  //     okText: 'Generate',
  //     className: 'confirm-pop-up',
  //     onOk() {
  //       handleGenerateCreditNote();
  //     },
  //     onCancel() {}
  //   });
  // };

  // eslint-disable-next-line no-unused-vars
  const handleSubmitLmDate = (lmDateData) => {
    const path = {
      ...apiConfig.return.fmLmConnection,
      path: apiConfig.return.fmLmConnection.path(id)
    };

    CallApi(
      path,
      undefined,
      lmDateData,
      {
        start: () => setLoading((prev) => ({ ...prev, addLmDate: true })),
        stop: () => setLoading((prev) => ({ ...prev, addLmDate: false }))
      },
      () => {
        message.success('FM Date details updated successfully');
        navigate(0);
      },
      (error) => message.error(getError(error))
    );
  };

  const downloadExcessQtyFile = async () => {
    try {
      const response = await getResponse({
        ...apiConfig.salesReturnOrder.downloadExcessQuantityCSV,
        path: apiConfig.salesReturnOrder.downloadExcessQuantityCSV.path(id)
      });
      downloadfileFromString(response, `Excess_Quantity_${id}.csv`);
    } catch (error) {
      message.error(getError(error));
    }
  };

  const handleExcessInwardOrder = () => {
    const path = {
      ...apiConfig.return.createExcessInwardOrder,
      path: apiConfig.return.createExcessInwardOrder.path(id)
    };

    CallApi(
      path,
      undefined,
      undefined,
      undefined,
      () => navigate(0),
      (error) => message.error(getError(error))
    );
  };

  const handleExcessQtyCSV = () => {
    const excessQtyDownload = async () => {
      try {
        const res = await getSalesOrderClient().roIdExcessSkuFileGet(id, {
          responseType: 'blob'
        });
        const fileURL = window.URL.createObjectURL(res?.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = `${grn_list?.[0]?.grn_number}_EXCESS_QTY.csv`;
        alink.click();
      } catch (error) {
        message.error(getError(error));
      }
    };
    excessQtyDownload();
  };

  const generateReverseSTN = () => {
    setStnActionType(STN_ACTION_TYPES.REVERSE_STN);
    setOpenModal('STN_ACTION');
  };

  const generateSTNInvoice = () => {
    setStnActionType(STN_ACTION_TYPES.STN_INVOICE);
    setOpenModal('STN_ACTION');
  };

  const generateSTNDC = () => {
    setStnActionType(STN_ACTION_TYPES.STN_DC);
    setOpenModal('STN_ACTION');
  };

  const handleStnAction = () => {
    const config = STN_ACTIONS_CONFIG[stnActionType];
    if (!config) return;

    const path = {
      ...config.apiConfig,
      path: config.apiConfig.path(id)
    };

    CallApi(
      path,
      undefined,
      undefined,
      {
        start: () => setLoading((prev) => ({ ...prev, stnAction: true })),
        stop: () => setLoading((prev) => ({ ...prev, stnAction: false }))
      },
      (response) => {
        message.success(response?.message || config.successMessage);
        setOpenModal('');
        setStnActionType(null);
        navigate(0);
      },
      (error) => {
        showErrorMessage(error);
        setLoading((prev) => ({ ...prev, stnAction: false }));
      }
    );
  };

  const items = [
    ...(transitions?.includes('RO_GENERATE_STN_DC')
      ? [
          {
            key: 'generate-stn-dc',
            label: (
              <button onClick={generateSTNDC} style={buttonStyle} type="button">
                {STN_ACTIONS_CONFIG.STN_DC.title}
              </button>
            ),
            icon: <FileTextOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_GENERATE_STN_CN')
      ? [
          {
            key: 'generate-reverse-stn',
            label: (
              <button onClick={generateReverseSTN} style={buttonStyle} type="button">
                {STN_ACTIONS_CONFIG.REVERSE_STN.title}
              </button>
            ),
            icon: <FileTextOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_GENERATE_STN_INVOICE')
      ? [
          {
            key: 'generate-stn-invoice',
            label: (
              <button onClick={generateSTNInvoice} style={buttonStyle} type="button">
                {STN_ACTIONS_CONFIG.STN_INVOICE.title}
              </button>
            ),
            icon: <FileTextOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_UPDATE_FM_DATE') || transitions?.includes('RO_UPDATE_LM_DATE')
      ? [
          {
            key: 'add-lm-date',
            label: (
              <button onClick={() => setOpenModal('ADD_LM_DATE')} style={buttonStyle} type="button">
                Add LM Date
              </button>
            ),
            icon: <CalendarOutlined />
          }
        ]
      : []),
    ...(actions?.includes('GENERATE_CREDIT_NOTE')
      ? [
          {
            key: 'generate-credit-note',
            label: (
              <button onClick={() => setOpenModal('GENERATE_CREDIT_NOTE')} style={buttonStyle} type="button">
                Generate Credit Note
              </button>
            ),
            icon: <PlusOutlined />
          }
        ]
      : []),
    ...(actions?.includes('DOWNLOAD_EXCESS_QTY_CSV')
      ? [
          {
            key: 'download-excess-qty-csv',
            label: <div onClick={downloadExcessQtyFile}>Download Excess Quantity File</div>,
            icon: <DownloadOutlined />
          }
        ]
      : []),
    ...(actions?.includes('CANCEL_INVOICE')
      ? [
          {
            key: 'cancel-e-invoice',
            label: (
              <button
                onClick={() => {
                  setOpenModal('CANCEL_E_INVOICE');
                  setCancelDocumentType('E_INVOICE');
                }}
                style={buttonStyle}
                type="button">
                Cancel E-Invoice
              </button>
            ),
            icon: <CloseOutlined />
          }
        ]
      : []),
    ...(actions?.includes('CANCEL_DELIVERY_CHALLAN')
      ? [
          {
            key: 'cancel-e-way-bill',
            label: (
              <button
                onClick={() => {
                  setOpenModal('CANCEL_E_INVOICE');
                  setCancelDocumentType('DELIVERY_CHALLAN');
                }}
                style={buttonStyle}
                type="button">
                Cancel Delivery Challan
              </button>
            ),
            icon: <CloseOutlined />
          }
        ]
      : []),
    ...(actions?.includes('CANCEL_CREDIT_NOTE')
      ? [
          {
            key: 'cancel-e-way-bill',
            label: (
              <button
                onClick={() => {
                  setOpenModal('CANCEL_E_INVOICE');
                  setCancelDocumentType('CREDIT_NOTE');
                }}
                style={buttonStyle}
                type="button">
                Cancel Credit Note
              </button>
            ),
            icon: <CloseOutlined />
          }
        ]
      : []),
    ...(actions?.includes('CANCEL_EWAYBILL')
      ? [
          {
            key: 'cancel-e-way-bill',
            label: (
              <button
                onClick={() => {
                  setOpenModal('CANCEL_E_INVOICE');
                  setCancelDocumentType('E_WAY_BILL');
                }}
                style={buttonStyle}
                type="button">
                Cancel E-Way Bill
              </button>
            ),
            icon: <CloseOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_CREATE_EXCESS_ORDER')
      ? [
          {
            key: 'excess-inward-order',
            label: (
              <button onClick={handleExcessInwardOrder} style={buttonStyle} type="button">
                Excess Inward Order
              </button>
            ),
            icon: <CloseOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_EXCESS_DOWNLOAD_FILE')
      ? [
          {
            key: 'excess-qty-csv',
            label: (
              <button onClick={handleExcessQtyCSV} style={buttonStyle} type="button">
                Excess Qty CSV
              </button>
            ),
            icon: <DownloadOutlined />
          }
        ]
      : []),
    ...(transitions?.includes('RO_LR_UPDATE')
      ? [
          {
            key: 'update-lr',
            label: (
              <button onClick={() => setOpenModal('UPDATE_LR')} style={buttonStyle} type="button">
                Update LR
              </button>
            ),
            icon: <EditOutlined />
          }
        ]
      : [])
  ];

  const getHistory = async () => {
    const response = await getHistoryClient().v1CommonEventHistory({
      referenceId: id,
      referenceType: 'SI_RO'
    });
    return response?.data?.data;
  };

  const getAttachmentHistory = async () => {
    const response = await getHistoryClient().v1CommonAttachmentHistory({
      referenceId: id,
      referenceType: 'SI_RO'
    });
    return response?.data?.data;
  };

  const headerProps = {
    title: `Sales RO : ${ro_number}`,
    tag: status,
    history: [],
    attachmentHistoryFetchFn: getAttachmentHistory,
    historyFetchFn: getHistory,
    info: {
      updatedBy: updated_by,
      updatedOn: moment(updated_on).format(Constants.DATE_FORMAT)
    },
    ...(true && {
      kebabMenu: (
        <Dropdown menu={{ items }}>
          <div className="menu" />
        </Dropdown>
      )
    })
  };

  const handleInvoiceCancel = () => {
    const paths = {
      E_INVOICE: apiConfig.return.cancelInvoice,
      E_WAY_BILL: apiConfig.return.cancelEWayBill,
      DELIVERY_CHALLAN: apiConfig.return.cancelDeliveryChallan,
      CREDIT_NOTE: apiConfig.return.cancelCreditNote
    };
    const path = {
      ...paths[cancelDocumentType],
      path: paths[cancelDocumentType].path(id)
    };
    const params = { remark: documentCancelRemark, reason: documentCancelReason };
    if (stnCancelOption === 'both') {
      params.cancel_stn_document = true;
    }

    CallApi(
      path,
      params,
      undefined,
      { start: () => setLoading('DOCUMENT_CANCEL'), stop: () => setLoading('') },
      (response) => navigate(0),
      showErrorMessage
    );
  };

  const cancelEInvoiceModal = (
    <ModalWrapper
      content={
        <Space direction="vertical w-100">
          <Text>{cancelOptions?.message}</Text>
          <Space className="w-100" direction="vertical">
            {cancelOptions?.stn_document_number ? (
              <Radio.Group onChange={(e) => setStnCancelOption(e.target.value)} value={stnCancelOption}>
                <Radio value="single">Single Document (Channel CN)</Radio>
                <Radio value="both">Both Documents (Channel CN & {cancelOptions?.stn_document_type})</Radio>
              </Radio.Group>
            ) : null}
            <Text className="required-after fw-500">Reason</Text>
            <Select
              className="w-100"
              onChange={(value) => setDocumentCancelReason(value)}
              options={Constants.DOCUMENT_CANCEL_REASONS}
            />
          </Space>
          <Text className="required-after fw-500">{cancelOptions?.reason_placeholder}</Text>
          <TextArea className="mt-10" onChange={(e) => setDocumentCancelRemark(e.target.value.trim())} rows={4} />
        </Space>
      }
      footer={
        <CommonModalFooter
          cancelButtonLabel={cancelOptions?.cancel_button_label}
          dangerSubmitButton
          ifSubmitDisabled={
            loading === 'CANCEL_E_INVOICE' ||
            !documentCancelRemark ||
            !documentCancelReason ||
            (cancelOptions?.stn_document_number && !stnCancelOption)
          }
          isCancelDisabled={loading === 'DOCUMENT_CANCEL'}
          loading={loading === 'DOCUMENT_CANCEL'}
          onCancel={() => {
            if (loading !== 'DOCUMENT_CANCEL') {
              setOpenModal('');
              setStnCancelOption(null);
            }
          }}
          onSubmit={handleInvoiceCancel}
          submitButtonLabel={cancelOptions?.confirm_button_label}
        />
      }
      loading={loading === 'CANCEL_OPTIONS'}
      onCancel={() => {
        if (loading !== 'DOCUMENT_CANCEL') {
          setOpenModal('');
          setStnCancelOption(null);
        }
      }}
      open={openModal === 'CANCEL_E_INVOICE'}
      title={cancelOptions?.title}
    />
  );

  const stnActionModal = (
    <ModalWrapper
      content={
        <div>
          <ExclamationCircleTwoTone twoToneColor="#faad14" />
          <Text style={{ marginLeft: 10 }}>
            {stnActionType ? STN_ACTIONS_CONFIG[stnActionType]?.confirmMessage : null}
          </Text>
        </div>
      }
      footer={
        <CommonModalFooter
          ifSubmitDisabled={loading?.stnAction}
          loading={loading?.stnAction}
          onCancel={() => {
            setOpenModal('');
            setStnActionType(null);
          }}
          onSubmit={handleStnAction}
          submitButtonLabel="Confirm"
        />
      }
      onCancel={() => {
        setOpenModal('');
        setStnActionType(null);
      }}
      open={openModal === 'STN_ACTION'}
      title={stnActionType ? STN_ACTIONS_CONFIG[stnActionType]?.title : null}
    />
  );

  return (
    <AppLayout selected="returnOrder">
      <LmDateModal
        initialData={return_order}
        loading={loading?.addLmDate}
        onClose={() => setOpenModal('')}
        onSubmit={handleSubmitLmDate}
        open={openModal === 'ADD_LM_DATE'}
        transitions={transitions}
      />
      {cancelEInvoiceModal}
      {generateCreditNoteModal}
      {stnActionModal}
      <UpdateLrModal
        apiEndpoint={apiConfig.return.patchLr}
        apiParams={{ roId: id }}
        defaultLrDate={dispatched_date}
        defaultLrNumber={lr_number || ''}
        deliveryDate={delivered_date}
        eWayBillDate={active_ewaybill?.issue_date}
        isOpen={openModal === 'UPDATE_LR'}
        onCancel={() => setOpenModal('')}
        onSuccess={() => navigate(0)}
      />
      <CustomHeader {...headerProps} />
      <Divider />
      <DetailsAndQty details={details} id={id} ifVendor={ifVendor} />
      <Lists GRNList={grn_list} id={id} SOType={SOType} />
    </AppLayout>
  );
};

const Lists = ({ GRNList, SOType }) => {
  const navigate = useNavigate();

  const handleGRNRowClick = (record) => {
    navigate(`/sales/ro-grn/${record?.id}`);
  };

  const GRNView = (
    <Table
      columns={GetColumns('ro_grn')}
      dataSource={GRNList}
      // onRow={(record) => ({
      //   onClick: () => handleGRNRowClick(record)
      // })}
      pagination={false}
      rowClassName="clickable-row"
      scroll={{
        x: 'max-content'
      }}
    />
  );

  const isGRNActive = GRNList?.find((GRN) => ['NEW', 'CREATED', 'CLOSED', 'IN_PROGRESS']?.includes(GRN?.status));

  const collapseHeaderGRN = (
    <Space className="jc-space-between w-100">
      <Title level={3}>Goods Received Note</Title>
    </Space>
  );

  return (
    <Collapse defaultActiveKey={['1']}>
      <Panel key="1" header={collapseHeaderGRN}>
        {GRNView}
      </Panel>
    </Collapse>
  );
};

const DetailsAndQty = ({ id, details, ifVendor }) => {
  const { return_order, attachments } = details || {};
  const {
    po_number,
    type,
    sales_model,
    brands,
    seller_shipping_entity,
    creation_date,
    total_payable_amount,
    currency,
    invoiced_quantity,
    po_id,
    packed_quantity,
    ordered_quantity,
    total_amount,
    seller_shipping_address,
    seller_billing_address,
    seller_billing_entity,
    return_type,
    return_sub_type,
    total_order_qty,
    total_received_qty,
    total_cancelled_qty,
    order_type
  } = return_order || {};
  const [activeTabKey, setActiveTabKey] = useState('overview');
  const tabList = [
    {
      key: 'overview',
      tab: 'Overview'
    },
    {
      key: 'details',
      tab: 'Details'
    },
    {
      key: 'documents',
      tab: 'Documents'
    }
  ];

  const PONumber = ifVendor ? po_number : <a href={`/sales/customer-po/${po_id}`}>{po_number}</a>;

  const contentList = {
    overview: (
      <Overview
        cols={[
          {
            items: [
              {
                label: 'RO Type',
                value: order_type
              },
              { label: 'Return Type', value: return_type },
              {
                label: 'Brand',
                value: brands?.map((brand) => brand?.name)?.join(', ')
              },
              {
                label: 'Seller Shipping Name',
                value: seller_shipping_entity?.name
              },
              {
                label: 'Seller Shipping Address',
                value: (
                  <Space direction="vertical">
                    <Address entity={seller_shipping_address} />
                  </Space>
                )
              },
              {
                label: 'Seller Billing Name',
                value: seller_billing_entity?.name
              },
              {
                label: 'Seller Billing Address',
                value: (
                  <Space direction="vertical">
                    <Address entity={seller_billing_address} />
                  </Space>
                )
              }
            ]
          },
          {
            items: [
              {
                label: 'Creation Date',
                value: getDateFromISO(creation_date)
              }
            ]
          }
        ]}
      />
    ),
    details: <ReturnDetails deliveredView details={details} />,
    documents: <Docs docs={[...(attachments?.length ? attachments : [])]} id={id} />
  };

  const stats = [
    {
      label: 'Received',
      value: total_received_qty
    },
    {
      label: 'Ordered',
      value: total_order_qty
    },
    {
      label: 'Cancelled',
      value: total_cancelled_qty
    }
  ];

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  return (
    <Row className="mb-30" gutter={16}>
      <Col span={18}>
        <Card
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          style={{
            width: '100%',
            height: '100%'
          }}
          tabList={tabList}>
          {contentList[activeTabKey]}
        </Card>
      </Col>
      <Col span={6}>
        <Card style={{ marginBottom: 12 }}>
          <Space className="jc-space-between flex">
            <Text style={LABEL_STYLE}>Amount</Text>
            <Text strong style={CONTENT_STYLE}>
              {getFormattedAmount(currency, total_payable_amount)}
            </Text>
          </Space>
        </Card>
        <Card
          style={{
            width: '100%',
            height: 400,
            overflow: 'auto'
          }}
          title="Quantity">
          <Space className="w-100 quantity-details" direction="vertical">
            {stats?.map((stat, index) => (
              // if (stat?.value)
              <React.Fragment key={`qty-${stat?.label}`}>
                <Space className="jc-space-between flex">
                  <Text style={LABEL_STYLE}>{stat?.label}</Text>
                  <Text strong style={CONTENT_STYLE}>
                    {getFormattedNumber(stat?.value)}
                  </Text>
                </Space>
                {index !== stats.length - 1 ? <Divider /> : null}
              </React.Fragment>
            ))}
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

const Docs = ({ id, docs }) => {
  return (
    <Space wrap>
      {docs.map((doc) => {
        return <DocumentCard key={`${doc?.pre_signed_url}`} link={doc?.pre_signed_url} name={doc?.label} />;
      })}
    </Space>
  );
};

export default ReturnDetailsDelivered;
